import { OrganizationRoutes } from "@simplyk/common";
import { useRouter } from "next/router";

export const useBackToFormTable = () => {
  const router = useRouter();

  const backToFormTableUrl = OrganizationRoutes.Campaigns;

  const backToFormTable = async () => {
    await router.push(backToFormTableUrl);
  };

  return { backToFormTable, backToFormTableUrl };
};
